import React from 'react'
import styles from './TranscriptionChat.module.scss'
import ChatMessage from 'components/ChatMessage/ChatMessage'

import { FetchResult } from 'components/FetchResult'
import { Spinner } from 'components/Spinner'

import { useFetch } from 'hooks'
import { callApi } from 'api'
import getCallType from 'utils/getCallType'

const parseTranscription = (value) => {
  if (!value) return []
  if (Array.isArray(value)) return value
  try {
    const parsed = JSON.parse(value)
    return Array.isArray(parsed) ? parsed : []
  } catch (err) {
    return []
  }
}

function TranscriptionChat({ transcription, roomID, variant }) {
  const callType = getCallType()

  const { loading, error, data } = useFetch(() =>
    callApi.getCallTranscription(callType, roomID)
  )
  const fetchedTranscription = parseTranscription(
    data?.result?.transcription || data?.result?.transcript || data?.result?.trascription
  )
  const providedTranscription = parseTranscription(transcription)

  return (
    <div className={styles.component}>
      {providedTranscription.length > 0 &&
        providedTranscription.map((item, index) => {
          return (
            <ChatMessage
              variant={variant}
              data={item}
              key={index}
              index={index}
              myName="Jake Smith"
            />
          )
        })}
      {providedTranscription.length === 0 && (
        <FetchResult
          error={error}
          status={loading}
          data={data}
          indicator={<Spinner className={styles.spinner} />}
        >
          <div className={styles.list}>
            {fetchedTranscription.map((item, index) => {
              return (
                <ChatMessage
                  variant={variant}
                  data={item}
                  key={index}
                  index={index}
                  myName="Jake Smith"
                />
              )
            })}
          </div>
        </FetchResult>
      )}
    </div>
  )
}

export default TranscriptionChat
